import { render, staticRenderFns } from "./TrackingCodeConfirm.vue?vue&type=template&id=b6b6a6bc&scoped=true"
import script from "./TrackingCodeConfirm.vue?vue&type=script&lang=js"
export * from "./TrackingCodeConfirm.vue?vue&type=script&lang=js"
import style0 from "./TrackingCodeConfirm.vue?vue&type=style&index=0&id=b6b6a6bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b6a6bc",
  null
  
)

export default component.exports